<template>
  <div class="pool-item" :class="active" @click="$emit('handleItem')">
    <div class="pool-item-inner" :style="{'background-image': 'url('+ imgSrc + ')'}"></div>
    <div class="pool-item-bg"></div>
    <slot name="mark"></slot>
  </div>
</template>

<script>
export default {
  props: {
    imgSrc: String,
    active: String
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/animation.scss';
.pool-item {
  @include flexrc;
  @include px2res(width, 134);
  @include px2res(height, 134);
  position: relative;
  .pool-item-bg {
    position: absolute;
    z-index: 1;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }
  .pool-item-inner {
    @include flexrc;
    @include px2res(width, 108);
    @include px2res(height, 108);
    background-size: contain;
  }
}
.pool-item.active {
  animation: scale-easeOutBounce .3s ease-out both;
}
</style>



// WEBPACK FOOTER //
// src/components/pool/item.vue